import { render, staticRenderFns } from "./PrintOnCloverSetting.vue?vue&type=template&id=1e563a64"
import script from "./PrintOnCloverSetting.vue?vue&type=script&lang=js"
export * from "./PrintOnCloverSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports